import Main from '@/module/base/view/main';
import parentView from '@/module/base/view/parent-view';

const _import = path => {
    return () => import(`@/module/main/views/${path}.vue`);
};
export default [

    {
        path: '/equip', name: 'equip', component: Main, meta: {icon: 'logo-buffer', title: '机械登记'},
        children: [
            {path: '/etype_mng', name: 'etype_mng', meta: {icon: 'md-add', title: '机械类型'}, component: _import('equip/etype')},
            {path: '/equip_mng', name: 'equip_mng', meta: {icon: 'md-add', title: '车辆信息'}, component: _import('equip/equip')},
            {path: '/archive_mng', name: 'archive_mng', meta: {icon: 'md-add', title: '机械档案'}, component: _import('equip/archive')},
            {path: '/insruance_mng', name: 'insruance_mng', meta: {icon: 'md-add', title: '保险管理'}, component: _import('equip/insurance')},
            {path: '/operator_mng', name: 'operator_mng', meta: {icon: 'md-add', title: '机械操作员'}, component: _import('equip/operator')}
        ]
    },
    {path: 'exam', name: 'exam', meta: {icon: 'md-add', title: '排放检测'}, component: Main,
        children:[
            {path: '/exam_apply_mng', name: 'exam_apply_mng', meta: {icon: 'md-add', title: '检测监控'}, component: _import('exam/examApply')},
            {path: '/exam_mng', name: 'exam_mng', meta: {icon: 'md-add', title: '检测报告'}, component: _import('exam/exam')},
            {path: '/examdepart_mng', name: 'examdepart_mng', meta: {icon: 'md-add', title: '检测单位'}, component: _import('exam/depart')},
            {path: '/examemployee_mng', name: 'examemployee_mng', meta: {icon: 'md-funnel', title: '检测人员',}, component: _import('exam/employee')},
            {path: '/instrument_mng', name: 'instrument_mng', meta: {icon: 'md-add', title: '检测设备'}, component: _import('exam/instrument')},
            {path: '/appointment_mng', name: 'appointment_mng', meta: {icon: 'md-add', title: '检测预约'}, component: _import('exam/appointment')}
        ]},
    {
        path: '/gps_mng', name: 'gps_mng', component: Main, meta: {icon: 'logo-buffer', title: '动态监控'},
        children: [
            {path: 'gps_status', name: 'gps_status', meta: {icon: 'md-add', title: '在线机械'}, component: _import('gps/status')},
            {path: 'gps_fence', name: 'gps_fence', meta: {icon: 'md-add', title: '低排区设置'}, component: _import('gps/fence')},
            {path: 'fence_draw', name: 'fence_draw', meta: {icon: 'md-add', title: '低排区添加'}, component: _import('gps/fence_draw')},
            {path: 'fence_alert', name: 'fence_alert', meta: {icon: 'md-add', title: '低排区报警'}, component: _import('gps/fence_alert')},
        ]
    },
    {path: 'violation', name: 'violation',redirect:'/violation_mng', meta: {icon: 'md-add', title: '监管执法',breadShow:false}, component:Main,children:[
            {path: '/violation_mng', name: 'violation_mng', meta: {icon: 'md-add', title: '监管执法'}, component: _import('violation')}
        ]},
    {
        path: '/govern_mng', name: 'govern_mng', component: Main, meta: {icon: 'logo-buffer', title: '尾气治理'},
        children: [
            {path: 'govern_work', name: 'govern_work', meta: {icon: 'md-add', title: '治理工单'}, component: _import('building')},
            {path: 'govern_result', name: 'govern_result', meta: {icon: 'md-add', title: '治理结果'}, component: _import('building')},
            {path: 'govern_book', name: 'govern_book', meta: {icon: 'md-add', title: '治理台账'}, component: _import('building')},
            {path: 'govern_m', name: 'govern_m', meta: {icon: 'md-add', title: 'M站管理'}, component: _import('building')},
            {path: 'af_factory', name: 'af_factory', meta: {icon: 'md-add', title: '后处理厂家'}, component: _import('building')},
            {path: 'af_parts', name: 'af_parts', meta: {icon: 'md-add', title: '后处理配件'}, component: _import('building')},
        ]
    },
    {
        path: '/site_mng', name: 'site_mng', component: Main, meta: {icon: 'logo-buffer', title: '场地管理'},
        children: [
            {path: 'project', name: 'project', meta: {icon: 'md-add', title: '项目管理'}, component: _import('building')},
            {path: 'site_in', name: 'site_in', meta: {icon: 'md-add', title: '进场管理'}, component: _import('building')},
            {path: 'oils_book', name: 'oils_book', meta: {icon: 'md-add', title: '油品台账'}, component: _import('building')},
        ]
    },
    {
        path: '/sta_mng', name: 'sta_mng', component: Main, meta: {icon: 'logo-buffer', title: '统计报表'},
        children: [
            {path: 'exam_sta', name: 'exam_sta', meta: {icon: 'md-add', title: '检测统计'}, component: _import('building')},
            {path: 'govern_sta', name: 'govern_sta', meta: {icon: 'md-add', title: '治理统计'}, component: _import('building')},
            {path: 'remove_alert', name: 'remove_alert', meta: {icon: 'md-add', title: '拆除报警'}, component: _import('building')},
            {path: 'out_alert', name: 'out_alert', meta: {icon: 'md-add', title: '越界报警'}, component: _import('building')},
            {path: 'high_alert', name: 'high_alert', meta: {icon: 'md-add', title: '超排报警'}, component: _import('building')},
            {path: 'day_alert', name: 'day_alert', meta: {icon: 'md-add', title: '日报警'}, component: _import('building')},
        ]
    },
    {
        path: '/setting', name: 'setting', component: Main, meta: {icon: 'logo-buffer', title: '基础设置'},
        children: [
            {path: 'password_update', name: 'password_update', meta: {icon: 'md-add', title: '密码修改'}, component: _import('setting/password')},
            {path: 'place_mng', name: 'place_mng', meta: {icon: 'md-add', title: '市/区管理'}, component: _import('setting/place')},
            {path: 'depart_mng', name: 'depart_mng', meta: {icon: 'md-funnel', title: '组织管理',}, component: _import('setting/depart')},
            {path: 'employee_mng', name: 'employee_mng', meta: {icon: 'md-funnel', title: '人员管理',}, component: _import('setting/employee')},
            {path: 'role_mng', name: 'role_mng', meta: {icon: 'md-funnel', title: '角色管理',}, component: _import('setting/role')},
            {path: 'sms_template', name: 'sms_template', meta: {icon: 'md-funnel', title: '短信模板',}, component: _import('setting/smsTemplate')},
        ]
    },
    {path: 'map', name: 'map',redirect:'/maptest', meta: {icon: 'md-add', title: '监管执法'}, component:Main,children:[
            {path: '/maptest', name: 'maptest', meta: {icon: 'md-add', title: '地图测试'}, component: _import('gps/mapTest')}
        ]},
    {path: '/printContent', name: 'printContent', meta: {icon: 'md-add', title: '监管执法'}, component:_import('exam/ReportContent')},
];
